import React from 'react';
import { useStyletron } from 'baseui';
import { StatefulPopover } from 'baseui/popover';
const getPopoverOverrides = () => ({
  Arrow: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundPrimary
    })
  },
  Inner: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundPrimary,
      boxShadow: 'none'
    })
  },
  Body: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundPrimary,
      boxShadow: $theme.lighting.shadow600
    })
  }
});
type ToolbarPopoverProps = {
  trigger: React.ReactNode;
  children: React.ReactNode;
};
export const ToolbarPopover = ({
  trigger,
  children
}: ToolbarPopoverProps) => {
  const [css, theme] = useStyletron();
  return <StatefulPopover placement="bottom" showArrow overrides={getPopoverOverrides()} content={() => <div className={css({
    display: 'flex',
    // -4px margin to accomodate the 4px marginLeft of the toolbar button
    marginLeft: `-${theme.sizing.scale100}`
  })}>
          {children}
        </div>}>
      {trigger}
    </StatefulPopover>;
};